import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavController } from 'providers/nav-controller';
import { IHelpCardPage } from 'pages/help-card-page/help-card-page-interface';

@Component({
    selector: 'help-icon',
    templateUrl: 'help-icon.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpIconComponent {
  @Input() name: string = 'help-circle';
  @Input() color: string = 'primary';
  @Input() helpId: string = '';
  @Input() size: 'large' | 'medium' | 'small' | 'x-small' = 'small';

  constructor(private navCtrl: NavController) { }

  onClick(event: MouseEvent) {
    void this.navCtrl.pushAsync(IHelpCardPage, {
      helpId: this.helpId,
    });
    event.stopPropagation();
  }
}
